import React, { useState } from 'react';
import { LockableContent, LockTooltip, Wrap } from './styles';

interface LockedSectionProps {
  locked: boolean;
  children: React.ReactNode;
}

const lockMessage = 'Schließe die vorherigen Schritte ab, um fortzufahren.';

const LockedSection: React.FC<LockedSectionProps> = ({ locked, children }) => {
  const [pos, setPos] = useState<{ top: number; left: number } | null>(null);

  return (
    <Wrap
      onMouseEnter={e => {
        if (!locked) return;
        const r = e.currentTarget.getBoundingClientRect();
        setPos({ top: r.top + r.height / 2, left: r.right + 12 });
      }}
      onMouseLeave={() => setPos(null)}
    >
      <LockableContent $locked={locked}>{children}</LockableContent>
      <LockTooltip $visible={!!pos} $top={pos?.top || 0} $left={pos?.left || 0}>
        {lockMessage}
      </LockTooltip>
    </Wrap>
  );
};

export default LockedSection;
